import { render, staticRenderFns } from "./AccountSeasonTickets.vue?vue&type=template&id=620d53a7&"
import script from "./AccountSeasonTickets.vue?vue&type=script&lang=js&"
export * from "./AccountSeasonTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports